import { isEmailValid } from "@shared/components/EmailInput/EmailValidation/EmailValidation";
import { IsNameValid } from "@unauthenticated/shared/components/NameValidation/NameValidation";

interface ConnectSignUpFields {
  firstName: string;
  lastName: string;
  email: string;
}

export const areRequiredFieldsValid = (
  { firstName, lastName, email }: ConnectSignUpFields,
  emailRegex: RegExp
) => IsNameValid(firstName) && IsNameValid(lastName) && isEmailValid(email, emailRegex);

export const isNameInvalid = (value: string, isDirty: boolean) =>
  isDirty && !!value && !IsNameValid(value);
